module.exports = __webpack_public_path__ + "img/icon.3252f95c.png";